import React from 'react'

function Choose() {
  return (
    <div className='dest'>
    <div className='container py-5'>
      <div className='down text-center py-5'>
        <h1>Choose Your Destination</h1>
        <p>Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla.</p>
        <button type="button" class="btn btn-lg mt-5 px-5 py-3 browse">
              Browse Destination
            </button>
      </div>
    </div>
    </div>
  )
}

export default Choose
